import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { completeCompany } from "../services/companyApi";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Alert, Spin, Tag } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import FormField from "../../../common/Form/FormField";
import Marquee from "react-fast-marquee";
import '../utils/style.css'

const CompleteCompany = ({ modal, setModal, toggle, selectedCompany, currentuser }) => {
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setisLoadingSubmit] = useState(false);
  const merchandId = currentuser?.user?.id;
  const kycVerified = currentuser?.user?.kycVerified;
  const companyId = selectedCompany?.id;

  const validationSchema = Yup.object().shape({
    nineaNumber: Yup.string().required("Veuillez renseigner sa nationalité"),
    businessRegistrationNumber: Yup.string().required("Il faut renseigner le registre de commerce"),
  });

  const initialValues = {
    nineaNumber: selectedCompany?.nineaNumber || "",
    businessRegistrationNumber: selectedCompany?.businessRegistrationNumber || "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      setisLoadingSubmit(true);
      try {
        const payload = {
          companyId,
          merchandId,
          nineaNumber: values.nineaNumber,
          businessRegistrationNumber: values.businessRegistrationNumber,
        };
        await completeCompany(payload);
        await queryClient.invalidateQueries("companies");
        toast.success("L'entreprise a été complétée avec succès 🎉");
        toggle();
        formik.resetForm();
      } catch (error) {
        console.error("Erreur :", error?.message || error);
        toast.error("😌 Erreur lors du complément de l'entreprise.");
      } finally {
        setisLoadingSubmit(false);
      }
    },
  });

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedCompany]);

  return (
    <Modal isOpen={modal} toggle={toggle} centered backdrop="static" className="modal-lg">
      <ModalHeader className="active-tab p-3" toggle={toggle}>
        Compléter les informations de mon entreprise <Tag color="cyan">{selectedCompany?.name}</Tag>{" "}
        <LoadingOutlined />
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Alert
            banner
            message={
              <Marquee pauseOnHover gradient={false}>
                Compléter les informations pour passer en prod. 🤭
              </Marquee>
            }
          />
          {kycVerified ? (
            <Row>
              <FormField label="Numéro de registre de commerce" name="businessRegistrationNumber" formik={formik} colSize={6} />
              <FormField label="Ninea" name="nineaNumber" formik={formik} colSize={6} />
            </Row>
          ) : (
            <div className="text-center incomplete-profile">
              Votre profil est incomplet 😒 <br />
              Merci de le compléter et revenir ici pour finir avec l'entreprise
              <Button className="active-tab" href={`${process.env.REACT_APP_API_KYC}/${merchandId}/kyc-status`}>
                Cliquer ici
              </Button>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          {kycVerified && (
            <>
              <Button color="light" onClick={() => setModal(false)}>Annuler</Button>
              <Button type="submit" disabled={isLoadingSubmit} className="active-tab">
                {isLoadingSubmit ? <Spin size="small" /> : 'Compléter'}
              </Button>
            </>
          )}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default CompleteCompany;
